import styled, { css } from "styled-components";
import healthExIllustrationImage from "../Media/HealthEx-illustration.png";
import researcherWelcomeBackImage from "../Media/ResearcherWelcomeBack.png";
import { FlexColumn, FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { HXTextField, withExplicitProps } from "./base.styles";
import { fontSizes } from "healthex-common/sizes";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import { HXButton } from "./HXButton";
export const OrgDetailsHolder = styled(FlexColumnDiv) `
    width: 100%;
    gap: 40px;
    flex-grow: 1;
`;
export const HealthExIllustrationImage = styled.div `
    background-image: url(${healthExIllustrationImage});
    background-repeat: no-repeat;
    height: 400px;
    width: 370px;
    flex-grow: 1;
`;
export const ResearcherWelcomeBackImage = styled.div `
    background-image: url(${researcherWelcomeBackImage});
    background-repeat: no-repeat;
    background-size: contain;
    height: 400px;
    width: 400px;
    flex-grow: 1;
`;
export const FormItem = styled.div `
    display: flex;
    align-items: center;
    padding: 5px 0px;
    font-size: ${fontSizes.SMALL};
`;
export const FormSection = styled(FlexColumnDiv) `
    gap: 16px;
    font-size: ${fontSizes.STANDARD};
`;
export const FormTextField = styled(HXTextField) `
    width: 100%;
`;
export const FormErrorMessage = styled.div `
    color: ${colors.tulip_main};
    font-size: 14px;
`;
export const FormTitle = withExplicitProps(styled.div, "required", "error") `
    font-weight: ${fontWeights.SEMI_BOLD};

    ${(props) => props.required &&
    css `
            &::after {
                content: " *";
                color: ${colors.tulip_main};
            }
        `}

    ${(props) => props.error &&
    css `
            color: ${colors.tulip_main};
        `}
    ${(props) => props.disabled &&
    css `
            color: ${colors.black_lighter};
        `}
`;
export const FormExplanation = styled.div `
    & ul {
        margin-top: 0;
        padding-left: 24px;

        & li {
            padding-left: 4px;
        }
    }
`;
export const FormStateDetails = styled(FlexRowDiv) `
    gap: 16px;
`;
export const WelcomeUserButton = styled(HXButton) `
    min-width: 200px;
`;
export const CenterAlignedButtonArea = styled(FlexColumn) `
    gap: 16px;
    align-items: center;
    justify-content: center;
    text-align: left;
`;
